<template>
  <form class="user-edit-body"
        @submit.prevent="submit">

    <div class="user-edit-body-wrapper">
      <div class="user-edit-body-column">

        <app-general-section v-model="form.general"
                             :step="false"
                             :entity="entity"
                             @advance="step++">
        </app-general-section>

        <app-address-section v-model="form.address"></app-address-section>

      </div>

      <div class="user-edit-body-column">
        <app-master-user-section v-model="form.masterUser"
                                 :step="false"
                                 :edit="true"
                                 @advance="step++"></app-master-user-section>

        <app-contact-section :label="$t('message.admGenerics.message.primaryContact')"
                             v-model="form.contacts[0]"
                             required></app-contact-section>

        <app-contact-section :label="$t('message.admGenerics.message.secondaryContact')"
                             v-model="form.contacts[1]"
                             secondary></app-contact-section>

      </div>
    </div>

    <app-user-modal-footer type="submit">{{$t('message.generics.message.save')}}</app-user-modal-footer>

  </form>
</template>

<script>
import userModalBody from "./mixins/user-modal-body";

export default {
  mixins: [userModalBody],
};
</script>

<style lang="scss" scoped>
.user-edit-body {
  height: calc(100vh - 310px);
  .user-edit-body-wrapper {
    display: flex;
    gap: 50px;

    .user-edit-body-column {
      flex: 1;
    }
  }

  .heading,
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70px;
  }

  .body {
    max-height: calc(100vh - 310px);
    overflow-y: auto;
  }
}
</style>
